/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const updatePreferencesResponseDataSchema = z.object({
  primaryLanguage: z.string().nullable(),
  detectiveMode: z.boolean(),
});

export type IUpdatePreferencesResponseData = z.infer<typeof updatePreferencesResponseDataSchema>;

export const updatePreferencesResponseSchema = createApiResponseSchema(
  updatePreferencesResponseDataSchema,
) as z.ZodSchema<IAPI<IUpdatePreferencesResponseData>>;

export type IUpdatePreferencesResponse = IAPI<IUpdatePreferencesResponseData>;
